export default "__VITE_ASSET__d03c9752__"